import { Component ,OnInit} from '@angular/core'
import { SummaryServiceProvider } from '../../../providers/wh/summary-service';
import { LoadingController, Loading, ModalController } from 'ionic-angular';
import { ChangeDriverPage } from './ecomerce.modal';
@Component({
    templateUrl: 'ecomerce.html',
    providers: [SummaryServiceProvider]
})
export class EcommercePage implements OnInit {
    loading: Loading
    items: any;
    header_data: any;
    constructor(private provider: SummaryServiceProvider, private loadingCtrl: LoadingController, private modalCtrl: ModalController) {
        this.header_data = { ismenu: true, ishome: false, title: "E-commerce" };
    }

    ngOnInit() {
        this.showLoading();
        this.provider.load_ecommerce_summary().then(data => {
            this.loadingDissmiss();
            let resp: any = data;
            this.items = resp.data;
            console.log(JSON.stringify(this.items))
        })
    }

    loadingDissmiss() {
        if (this.loading != null && this.loading.isOverlay) {
            this.loading.dismiss();
        }
    }

    showLoading() {
        this.loading = this.loadingCtrl.create({
            content: "Please Wait..."
        });
        this.loading.present();
    }

    changeDriver(ecommerceId, driverId) {
        let param = { "ecommerceId": ecommerceId, "driverId": driverId };
        let modalPage = this.modalCtrl.create(ChangeDriverPage, param);
        modalPage.onDidDismiss(isRefresh => {
            if (isRefresh) {
                this.ngOnInit();
            }
        });
        modalPage.present();
    }
}


// WEBPACK FOOTER //
// ./src/pages/backoffice/ecomerce/ecomerce.ts